import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";

import { IconTrash03 } from "@pentabd/icons";
import { Button } from "@pentabd/ui";
import { ContractualPostingForm } from "./ContractualPostingForm";

import { contractualPostingValidation } from "@validations/HRM/employee/postingsValidation";
import { ContractualPostingType } from "@type/HRM/postings";

interface ContractualPostingPropsType {
  contractualPostingInfo?: ContractualPostingType;
  changeContractualPostingsInfo?: any;
  removeContractualPostingInfo?: any;
}

export const ContractualPosting = ({
  contractualPostingInfo,
  changeContractualPostingsInfo,
  removeContractualPostingInfo,
}: ContractualPostingPropsType) => {
  const { t } = useTranslation();
  const methods = useForm<ContractualPostingType>({
    resolver: yupResolver(contractualPostingValidation),
    values: contractualPostingInfo as ContractualPostingType,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<ContractualPostingType> = (
    data: ContractualPostingType
  ) => {
    changeContractualPostingsInfo(data);
  };

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        <ContractualPostingForm
          id={
            contractualPostingInfo && contractualPostingInfo.id
              ? contractualPostingInfo.id
              : "TEMP_CONTRACTUAL_POSTING_INFO"
          }
        />

        <div className="row py-10">
          <div className="text-end col-12 col-lg-10">
            <div className="d-flex gap-8 flex-row-reverse">
              <Button
                htmlType="button"
                type="danger"
                fill="outline"
                size="sm"
                onClick={() =>
                  removeContractualPostingInfo(contractualPostingInfo)
                }
                disabled={!contractualPostingInfo || !contractualPostingInfo.id}
              >
                <IconTrash03 size="20" fill="danger" />
                {t("EMPLOYEE.POSTINGS_INFO.FORM.DELETE_BUTTON")}
              </Button>

              <Button
                key="contractual_posting_save_bottom"
                // loading={updateParentRequest}
                htmlType="submit"
                fill="outline"
                type="primary"
                size="sm"
              >
                {t("EMPLOYEE.POSTINGS_INFO.FORM.SAVE_BUTTON")}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};
